import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import {
  ModalBaseStyles,
  ModalHeader,
  ModalDrawerButtonStyles,
} from "../../Common/styles/modal";

type Props = {
  openModal: boolean;
  closeModal: () => void;
};

const NoAccessModal = ({ openModal, closeModal }: Props) => {
  return (
    <Modal open={openModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title="Access Denied" onCloseClick={closeModal} />
        <Typography variant="body1" sx={{ mb: 2 }}>
          You do not have edit access to any of the selected participants or the
          participants are not eligible for consent and sunshine forms. Please
          select participants from sites where you have edit permissions and are
          part of an user group.
        </Typography>
        <Box sx={ModalDrawerButtonStyles}>
          <Button onClick={closeModal} variant="contained">
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoAccessModal;
